<template>
  <v-container class="about-page">
    <div>
      <div class="bg-fixed-100" :style="{ backgroundImage: 'url(' + aboutBg + ')' }"></div>

      <div class="content">
        <router-link :to="{ name: 'Home'}">
          <img :src="$root.logo" class="about-logo">
        </router-link>

        <iconClose @click="onClose" class="icon-close"></iconClose>
        <h4>welcome aboard lokomotive ooo</h4>
<h5 class="mb-6">an individual approach to clothing</h5>

<h4>experience a world that you may have forgotten</h4>
Join us on a journey and pass through the various compartments of
unique glamour, artisanal craftmanship and traditional values.
LOKOMOTIVE OOO only stops at stations to seek aesthetic
inspiration which creates collections and generates its personal
interpretations.

<h4 class="mt-6">olivia schuler-voith</h4>
<h5 class="mb-6">THE CREATIVE FOUNDER</h5>
I want to inspire people with creative ideas fueled by Christian
values, so we consciously enjoy the gift of co-creating a better world.
Having my roots in set and costume design as well as in history of
art, I founded LOKOMOTIVE OOO in 2020. We offer an alternative to
regular garment production as we know it by introducing our
individual way of tailoring.
My approach to fashion is unconventional. Since my childhood I was
influenced by nostalgic and aesthetic environments. I often got lost
in my self-created worlds inspired by interiors, books, paintings and
old movies.
I am highly influenced by my every day visual experiences like
traveling on regional trains through Switzerland that enable me to
explore the world around me.

<h4 class="mt-6">how we roll</h4>

<h5>A BRIDGE BETWEEN HERITAGE AND GLAMOUR</h5>
LOKOMOTIVE OOO stands for positive motion bringing back
beautifully crafted designs from various cultural and historical
environments.
Our creations are manufactured in an artisanal manner supporting
local craftsmanship particularly in the Alpine region where we are
headquartered and where we work with small Ateliers and
independent artisans.
We produce in small numbers–– special editions and tailored orders.
Each product can be adapted to your taste and wishes and make you
a co-creator!
As you might guess we share with you the issue of our common
environmental concern. We do our part to keep steering our
LOKOMOTIVE OOO on the right track.

<h4 class="mt-6">bring nostalgic aesthetic back to the moment</h4>
As mission driven people we want to live each moment consciously
which permits us to embrace our nostalgic longing that fills our
everyday life with joy.
Your personal experience as a passenger of LOKOMOTIVE OOO sets
it in motion to reach ever new destinations.
      </div>
    </div>
  </v-container>
</template>

<script>
import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'
import aboutBg from '@/assets/img/about-bg.jpg'
import iconClose from '@/assets/svg/cross-icon.svg'
import aboutTexture from '@/assets/img/about-texture.jpg'

export default {
  name: 'About',

  mixins: [Viewport],

  components: {
    iconClose
  },
  data () {
    return {
      aboutBg,
      aboutTexture
    }
  },

  methods: {
    onClose () {
      this.$router.push({ name: 'Home' })
    }
  },

  watch: {
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.about-page {
  text-align: center;
}

.about-logo {
  width: 200px;
  position: absolute;
  left: 0;
  top: 10px;
}

.icon-close {
  position: absolute;
  top: 20px;
  right: 20px;
}

.content {
  background-size: 100% 100%;
  position: relative;
  width: 80%;
  padding: 100px 60px;
  margin: 50px auto;
  background-color: $c-yellow;
  border: 20px solid $c-red;

  @include breakpoint('xs-only') {
    width: 100%;
    padding: 10px;
  }

  h4 {
    text-transform: capitalize;
  }

  p {
    margin-top: 60px;
    font-size: 20px;
    line-height: 28px;

    @include breakpoint('xs-only') {
      margin-top: 30px;
      font-size: 14px;
      line-height: 24px;

    }
  }
}

.home-title {
  position: relative;
  margin-top: 10%;
  padding: 10px 40px;
  color: $c-red;
  text-align: center;

  h1,
  h4 {
    font-weight: 500;
  }

  h1 {
    margin-top: -40px;

    @include breakpoint('xs-only') {
      margin-top: 0;
    }
  }
}

</style>
